import 'Plugins/customHoverPlugin';

export default function initCustomHover() {
	jQuery('.grid-block a.card').touchHover({});
}